import { Component, ChangeDetectionStrategy, OnInit, TemplateRef } from '@angular/core';
import { SettingsService, MenuService } from '@delon/theme';
import { navItems } from '@shared/constants/menu_itens.const';
import { SecurityService } from '@shared/services/security.service';
import { SubjectModel } from '@shared/models/subject.model';
import { Router } from '@angular/router';
import { MessagesService, NotificationType } from '@shared/services/message.service';
import { UploadChangeParam } from 'ng-zorro-antd';

@Component({
  selector: 'layout-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit {

  subject: SubjectModel;
  collapsed: boolean = true;
  displayUpload: boolean = false;

  constructor(
    public settings: SettingsService,
    private securityService: SecurityService,
    private menuService: MenuService,
    private router: Router,
    private messageService: MessagesService) {

    this.subject = securityService.subject;
    this.settings.notify.subscribe(() => {
      this.collapsed = this.settings.layout.collapsed
    })

    this.menuService.add(this.itens());

    securityService.permissions.subscribe(value => {
      this.menuService.add(this.itens());
    });
  }

  private itens() {
    const its = [];
    navItems.forEach(value => its.push(JSON.parse(JSON.stringify(value))));
    return its;
  }

  logout() {
    this.router.navigate(['/auth/login']);
  }

  ngOnInit() {
  }

  openMenu() {
    if (!this.settings.layout.frozen) {
      this.settings.setLayout('collapsed', false);
    }
  }

  closeMenu() {
    if (!this.settings.layout.frozen) {
      this.settings.setLayout('collapsed', true);
    }
  }

  closeUpload() {
    this.displayUpload = false
  }

  handleUploadChange(change: UploadChangeParam) {
    const { type } = change;
    if (type === 'success') {
      this.messageService.notify('Foto atualizada com sucesso!', NotificationType.Success)
      this.closeUpload()
    } else if (type === 'error') {
      this.messageService.notify('Ocorreu uma falha ao atualizar a foto', NotificationType.Error)
    }

  }

}
